import { AutoCloseWarning } from '@/components/alerts/AutoCloseWarning';
import { ReturnForRevisionModal } from '@/features/tasks/task-overlays/ReturnForRevisionModal';
import { ResultRequiredModal } from '@/features/tasks/task-overlays/ResultRequiredModal';
import { TaskExtensionModal } from '@/features/tasks/task-dialogs/TaskExtensionModal';
import { TaskSelectionModal } from '@/features/tasks/task-dialogs/TaskSelectionModal';
import { TimeUpModal } from '@/features/tasks/task-overlays/TimeUpModal';

export function AppGlobalOverlays() {
  return (
    <>
      <AutoCloseWarning />
      <TaskExtensionModal />
      <TimeUpModal />
      <ResultRequiredModal />
      <ReturnForRevisionModal />
      <TaskSelectionModal />
    </>
  );
}
